import { useEffect, useState } from "react";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { toast } from "react-toastify";
import { CRSelectorConstants } from "../../../../bpm/config/Componentes/CRSelectorConstants";

interface addCondition {
    DiscountCode: number;
    DiscountName: string;
}

interface Props {
    jsonProps: string;
    onChange: Function;
}

export const ListDiscountCodes = ({ jsonProps, onChange }: Props) => {

    const [format, setFortmat] = useState<Partial<addCondition>>({});
    const [lista, setLista] = useState([]);

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {
        try {
            if (jsonProps && jsonProps.trim() !== "") {
                const parsed = JSON.parse(jsonProps);
                if (Array.isArray(parsed)) {
                    setLista(parsed);
                } else {
                    toast.error("El formato de jsonProps no es una lista válida.");
                    setLista([]);
                }
            } else {
                setLista([]);
            }
        } catch (error) {
            toast.error("Error al parsear jsonProps.");
            setLista([]);
        }
    };


    const create = () => {
        if (!format.DiscountCode) {
            toast.error("digite un codigo de descuento valido");
            return;
        } else if (!format.DiscountName) {
            toast.error("digite un Nombre de descuento valido");
            return;
        }

        const updatedCode = format;
        setLista([...lista, updatedCode]);

        setFortmat({
            DiscountCode: null,
            DiscountName: "",
        });
    };


    const deleteItem = (index: number) => {
        const nuevaLista = lista.filter((_, i) => i !== index);
        setLista(nuevaLista);
    };

    useEffect(() => {
        if (onChange) {
            onChange(JSON.stringify(lista))
        }
    }, [lista])

    return (
        <div className="row">
            <div className="col-md-12 mb-3">
                <div className="row">
                    <div className="col-md-5">
                        <label >Codigo de Descuento</label>
                        <input type="number" className="form-control" value={format.DiscountCode} onChange={(e) => { setFortmat({ ...format, DiscountCode: parseInt(e.target.value) }) }} />
                    </div>

                    <div className="col-md-5">
                        <label >Nombre del Descuento</label>
                        <input type="text" className="form-control" value={format.DiscountName} onChange={(e) => { setFortmat({ ...format, DiscountName: e.target.value }) }} />
                    </div>

                    <div className="col-md-2 d-flex align-items-end">
                        <BasicButton eventClick={create} icon="ri-file-add-line">Agregar</BasicButton>
                    </div>
                </div>
            </div>

            <div className="col-md-12">
                <table className="table table-bordered table-hover">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Codigo de Descuento</th>
                            <th>Descuento</th>
                        </tr>
                    </thead>
                    <tbody>
                        {lista.map((item, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{item.DiscountCode}</td>
                                <td>{item.DiscountName}</td>
                                <td>
                                    <BasicButton
                                        eventClick={() => deleteItem(index)}
                                        icon="ri-delete-bin-line"
                                        children="Eliminar"
                                    />
                                </td>
                            </tr>
                        ))}
                        {lista.length === 0 && (
                            <tr>
                                <td colSpan={6} className="text-center">No hay codigos de Descuento Configurados</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}